import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Vue3TouchEvents from 'vue3-touch-events'
import App from './App.vue'
import './assets/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(Vue3TouchEvents, {
  disableClick: false,
  touchClass: 'is-touching',
  swipeTolerance: 50,
  tapTolerance: 10
})
app.mount('#app')
